module.exports = __webpack_public_path__ + "img/Group76.58a25a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Group76.png
// module id = /h/t
// module chunks = 1